<template>
  <div class="blog-list" id="blogListContainer">
    <div
      class="
        uk-grid-match
        uk-child-width-1-1
        uk-child-width-1-2@s
        uk-child-width-1-3@m
        uk-text-center
        uk-grid-medium
      "
      uk-grid
    >
      <div v-for="blog in this.displayBlogs" :key="blog.slug_name">
        <blog-item :blog="blog" />
      </div>
    </div>
  </div>
</template>
<script>
import BlogItem from "@/components/blogs/BlogItem";
export default {
  name: "IndexBlogList",
  props: ["blogs"],
  components: { BlogItem },
  data() {
    return {
      maxItemInPage: 6,
    };
  },
  computed: {
    displayBlogs() {
      if (this.blogs) {
        return this.blogs.slice(0, this.maxItemInPage);
      } else {
        return [];
      }
    }
  },
  methods: {
    checkMediaQuery() {
      if (window.innerWidth < 640) {
        this.maxItemInPage = 3;
      } else if (window.innerWidth < 960) {
        this.maxItemInPage = 4;
      } else {
        this.maxItemInPage = 6;
      }
    },
  },
  mounted() {
    this.checkMediaQuery();
    window.addEventListener("resize", this.checkMediaQuery);
  },
};
</script>
<style lang="scss" scoped>
.page-selector {
  margin: 100px auto;
  text-align: center;
  .page-btn {
    border-radius: 50%;
    background-color: #003232;
    display: inline-block;
    width: 43px;
    height: 43px;
    margin: 0 3px;
    background-color: #b6d0c0;
    font-size: 24px;
    line-height: 43px;
    text-align: center;
    font-weight: normal;
    color: #fff;
    border: none;
    padding: 0;
    &.selected {
      background-color: #003232;
    }
    @media (min-width: 960px) {
      &:hover {
        background-color: #408282;
      }
    }
  }
}
.blog-list {
  padding-bottom: 61px;
}
@media (min-width: 960px) {
  .blog-list {
    padding: 0 95px 64px;
  }
}
</style>